import { Component } from 'vue-property-decorator'
import { LoadList } from '@shared/mixins/loadList'
import { Toast } from 'vant'
import { getShareIncome, getUserAccount, getStoreIncomeList } from './commission.service'
import { toArray } from 'lodash'
import { toCzj, copy } from '@utils/index'
import { FILTERLIST } from './commission.config'
import SpuComponent from './components/spu.component.vue'
import MatronComponent from './components/matron.component.vue'
import CommissionTabbar from './components/commission-tabbar.vue'
@Component({
  components: {
    SpuComponent,
    MatronComponent,
    CommissionTabbar
  }
})
export default class CommissionPage extends LoadList {
  account = 0 //账户余额
  oldAccountAmount = 0 //老账户余额
  filterList = FILTERLIST
  filterStatus = FILTERLIST[0].status
  shareIncome = {}

  mounted() {
    // this.$setTitle('我的佣金')
    this.$setTitle('服务佣金')
    this.getUserAccount()
    this.getShareIncome()
    this.getList()
  }
  // copyText(text: string) {
  //   copy.text(text)
  // }
  async getShareIncome() {
    const res: ResponseCode = await getShareIncome()
    if (res.code == '1') {
      this.shareIncome = res.data
    } else {
      Toast(res.msg)
    }
  }
  changeFilter(status: any) {
    this.filterStatus = status
    this.setInitResult()
    this.getList()
  }
  onLoad() {
    this.getList()
  }
  async getList() {
    const pageIndex = ++this.result.pageIndex
    const pageSize = this.result.pageSize
    this.result.loading = true

    if (pageIndex === 1) {
      this.result.list = []
    }
    const response: ResponseCode = await getStoreIncomeList({
      start: this.result.list.length,
      rows: pageSize,
      selectStatus: this.filterStatus || 1
    })
    this.result.loading = false
    if (response.code == 1) {
      //this.data.total = response.data.total
      const list: any[] = toArray(response.data)
      // const list: any[] = [{
      //   shopName: '门店名称',
      //   dueTime: '2022-1-20',
      //   itemState: 1,
      //   title: '名称啊啊啊啊',
      //   skuName: '规格名称',
      //   vorderId: '123',
      //   mobile: '17775217174',
      //   orderTime: '2022-1-23',
      //   actPrice: '220',
      //   income: '20',
      //   money: {
      //     typeName: 111,
      //     empRate: 222,
      //     status: 1,
      //     salerMoney: 222
      //   },
      //   coverUrl: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.jj20.com%2Fup%2Fallimg%2F4k%2Fs%2F02%2F2109242332225H9-0-lp.jpg&refer=http%3A%2F%2Fimg.jj20.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1644997609&t=e13fe6b8d55c50aacfeb4a2f967d6419'
      // }]
      this.result.list = this.result.list.concat(list)
      if (list.length < pageSize) {
        this.result.finished = true
      }
    } else {
      --this.result.pageIndex
      this.result.error = true
    }
  }
  async getUserAccount() {
    const res: ResponseErrno = await getUserAccount()
    if (res && res.errno == 0 && res.data) {
      this.account = res.data.withdrawAmount
      this.oldAccountAmount = res.data.oldAccountWithdrawAmount || 0
    }
  }
  toWithdraw() {
    toCzj('//m.czj100.com/port/cash/?cmd=share&sharetype=0')
  }
  toCashRecords() {
    toCzj('//m.czj100.com/port/cash/records?cmd=share&sharetype=0')
  }
}
